module.exports = __webpack_public_path__ + "img/20210619_172006.60864e3d.jpg";